<script lang="ts" module>
  import type { ApiBackendError } from '@/teoCore/errors/ApiError';
  import type { PWResetResult } from '@/teoCore/TeoApi';
  import LoginCard from '@/ui/elements/login/LoginCard.svelte';
  import InputLogin, { isValidEmail } from '@/ui/elements/text-input/TextInput.svelte';

  import { isApiBackendError, type LoginState } from '../LoginElement.svelte';
  import { useAuth } from '../use-auth.svelte';

  export interface LoginGeneralProps {
    loginState: LoginState;
    apiError?: string;
  }
</script>

<script lang="ts">
  let [, { requestPasswortReset }] = useAuth();
  let { loginState = $bindable() }: LoginGeneralProps = $props();
  let mailError: string | undefined = $state(undefined);

  const validate = () => {
    let returnState = true;
    const res = isValidEmail(loginState.userName);
    returnState = returnState && res.result;
    mailError = res.errorMsg;
    return returnState;
  };

  const onSubmit = () => {
    requestPasswortReset(loginState.userName).then((value: PWResetResult | ApiBackendError) => {
      if (isApiBackendError(value)) {
        console.log('API Error:', value);
        mailError = 'Die E-Mail Adresse konnte nicht gefunden werden.';
      } else {
        loginState.resetMail = loginState.userName;
        loginState.state = 'loginResetConfirm';
      }
    });
  };
</script>

<LoginCard
  showNWP={true}
  headline="Herzlich Willkommen"
  text="Für welchen Account soll das Passwort zurückgesetzt werden?"
  ctaLabel="Zurücksetzen"
  {onSubmit}
  {validate}
  postLink={{
    label: 'Zurück zum Login',
    target: () => {
      loginState.state = loginState.mainPage ?? 'loginGeneral';
    },
  }}
>
  <div class="flex justify-center">
    <InputLogin
      id="login-pw-reset-email"
      label="E-Mail"
      type="text"
      bind:value={loginState.userName}
      errorMsg={mailError}
    ></InputLogin>
  </div>
</LoginCard>
